import axios from "axios";

export const TOKEN_KEY = "nxc_token";
/** Same-origin when the app is served from any nexsecure.in host (nexsecure.in, connect.nexsecure.in) — avoids CORS; the preview/APK keep the configured backend. */
export const BACKEND = typeof window !== "undefined" && /(^|\.)nexsecure\.in$/.test(window.location.hostname) ? window.location.origin : process.env.REACT_APP_BACKEND_URL;
export const api = axios.create({ baseURL: `${BACKEND}/api/connect` });

api.interceptors.request.use((cfg) => {
  const t = localStorage.getItem(TOKEN_KEY);
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});

export const errText = (e) => {
  const d = e?.response?.data?.detail;
  if (!d) return e?.message || "Something went wrong";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x?.msg || JSON.stringify(x)).join(" ");
  return d?.msg || String(d);
};

api.interceptors.response.use((r) => r, (e) => {
  const st = e?.response?.status, d = e?.response?.data?.detail;
  if (st === 401 && localStorage.getItem(TOKEN_KEY)) {
    localStorage.removeItem(TOKEN_KEY);
    // only a genuine expiry gets a note on the sign-in screen; every other forced sign-out is silent
    if (typeof d === "string" && (d.startsWith("Session expired") || d.startsWith("Your account has been suspended") || d === "This account does not exist.")) sessionStorage.setItem("nxc_revoked", d);
    window.location.assign("/connect");
  }
  return Promise.reject(e);
});
